import { lazyRetry } from '@/shared/core/lazyRetry';

export const AgentLogin = lazyRetry(() => import('./pages/AgentLogin'));
export const AgentCasesWorkspace = lazyRetry(() => import('./pages/AgentCasesWorkspace'));
export const AgentSubmitLeads = lazyRetry(() => import('./pages/AgentSubmitLeads'));
export const AgentMySubmissions = lazyRetry(() => import('./pages/AgentMySubmissions'));
export const AgentCreateQuote = lazyRetry(() => import('./pages/AgentCreateQuote'));
export const AgentMyQuotes = lazyRetry(() => import('./pages/AgentMyQuotes'));
